import { getUserAgent } from './get-user-agent';
import { isMobile } from './is-mobile';
export function isMac(ua) {
    return !isMobile(ua) && /macintosh|mac os x/i.test(getUserAgent(ua));
}
